import { defineComponent, watch, onUnmounted, ref } from 'vue';
import ItemDetailBanner from './components/ItemDetailBanner.vue';
import ItemDetailBox from '@/components/ItemDetailBox.vue';
import ItemDetailNavBar from '@/components/ItemDetailNavBar.vue';
import { ItemService } from '@/services/item.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { useRoute, useRouter } from 'vue-router';
import { UserService } from '@/services/user.service';
import { isInIframe } from '@/utils';
export default defineComponent({
  name: 'ItemDetail',
  components: {
    ItemDetailBanner: ItemDetailBanner,
    ItemDetailBox: ItemDetailBox,
    ItemDetailNavBar: ItemDetailNavBar
  },
  setup: function () {
    declareProviders([ItemService]);
    var userService = useService(UserService);
    var itemService = useService(ItemService);
    var route = useRoute();
    var router = useRouter();
    var extraFileHtml = ref('');
    var id = +route.params.id;
    var updateContestInfo = function () {
      var inIframe = isInIframe();
      itemService.getContestDetailInfo(id, {
        source: inIframe ? 'b2c' : undefined
      }).catch(function (e) {
        // add sentry mark
        // console.log('setTag', 'api', 'updateContestInfo');
        router.replace({
          name: 'UserItemList'
        });
      });
    };
    onUnmounted(function () {
      itemService.clearTimer();
    });
    watch(function () {
      return userService.user;
    }, function () {
      updateContestInfo();
    }, {
      immediate: true
    });
    var createExtraFileHtml = function (data) {
      var txt = '<ul>';
      return txt.concat(data.map(function (url, index) {
        var name = decodeURIComponent(url.split('/').pop());
        return "<li><a href=\"".concat(url, "\" target=\"_blank\">").concat(name, "</a></li>");
      }).join('<a-divider></a-divider>')).concat('</ul>');
    };
    watch(function () {
      return itemService.item;
    }, function () {
      var _a, _b;
      if ((_b = (_a = itemService.item) === null || _a === void 0 ? void 0 : _a.appendixUrlList) === null || _b === void 0 ? void 0 : _b.length) {
        extraFileHtml.value = createExtraFileHtml(itemService.item.appendixUrlList);
      } else {
        extraFileHtml.value = '';
      }
    }, {
      immediate: true
    });
    return {
      itemService: itemService,
      extraFileHtml: extraFileHtml
    };
  }
});